export default __webpack_public_path__ + "static/media/Iron Band of Constitution.54d7e9d1.jpg";